<ng-container *ngIf="formMap | async let form">
    <ng-container *ngIf="sentinelProvisioningService.selectedFacility?.facility as facility">
        <p-card styleClass="p-my-2">
            <ng-template pTemplate="body">
                <div class="p-grid">
                    <div *ngIf="facility.facilityName as name" class="p-col-12">
                        <label>{{name}}</label>
                    </div>
                    <div class="p-col-12 p-fluid">
                        <label for="accessPointName">
                            Door Name
                        </label>
                        <input id="accessPointName" type="text" pInputText [formControl]="form.accessPointName" />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-divider></p-divider>
                <div class="p-d-flex p-jc-end">
                    <button pButton (click)="stopEditing()" label="Cancel" class="p-button-secondary p-mr-2"></button>
                    <button pButton (click)="!validate(form) && save($any(facility), form)" label="Save"></button>
                </div>
                <div *ngIf="errorMessage" class="p-d-flex p-jc-end">
                    <p-message severity="error" [text]="errorMessage"></p-message>
                </div>
            </ng-template>
        </p-card>
    </ng-container>
</ng-container>